import { tabType } from "../../constants";

export const SUB_TABS_IMAGE: { [key: string]: tabType } = {
    DUPLICATE: {
        index: 2,
        title: "Duplicate",
    },
    FLIP_V: {
        index: 3,
        title: "Flip V",
    },
    FLIP_H: {
        index: 4,
        title: "Flip H"
    },
    ALIGN_LEFT: {
        index: 5,
        title: "Align Left"
    },
    ALIGN_RIGHT: {
        index: 6,
        title: 'Align right'
    },
    ALIGN_CENTER: {
        index: 7,
        title: 'Align center'
    },
    ALIGN_TOP: {
        index: 8,
        title: 'Align top'
    },
    ALIGN_BOTTOM: {
        index: 9,
        title: 'Align bottom'
    },
    BRING_FRONT: {
        index: 10,
        title: 'Bring to front'
    },
    SEND_BACK:{
        index: 11,
        title: 'Send to back'
    }
}